import Accordion from '@pcln/accordion'
import { Box, Hug, Text } from 'pcln-design-system'
import React, { useState } from 'react'

const Faqs = ({
  answerTextStyle = 'paragraph',
  faqs = [],
  questionTextStyle = 'subheading5',
  onClick = () => {},
}) => {
  const [accordionOpenStates, setAccordionOpenStates] = useState(Array(faqs.length).fill(false))
  return (
    <>
      {faqs.map(({ question, answer }, index) => {
        return (
          <Box mb={2} key={question}>
            <Accordion>
              <Hug
                bg={accordionOpenStates[index] ? 'background.light' : 'background.base'}
                color='primary.base'
                text={
                  <Accordion.Trigger size={24} color='primary.base' onClick={onClick}>
                    <Text
                      textStyle={questionTextStyle}
                      onClick={() => {
                        onClick()
                        const updatedState = [...accordionOpenStates]
                        updatedState[index] = !accordionOpenStates[index]
                        setAccordionOpenStates(updatedState)
                      }}
                    >
                      {question}
                    </Text>
                  </Accordion.Trigger>
                }
              >
                <Accordion.Content p={3} bg='background.light'>
                  <Text textStyle={answerTextStyle} color='text.light'>
                    {answer}
                  </Text>
                </Accordion.Content>
              </Hug>
            </Accordion>
          </Box>
        )
      })}
    </>
  )
}

export { Faqs }
export default Faqs
